import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import every from 'lodash/every';
import get from 'lodash/get';
import { compose, lifecycle, withHandlers, withProps } from 'recompose';
import ShopTable from '../components/ShopTable';
import EmptyList from '../components/EmptyList';
import withLoadingList from '../../../../common/hoc/withLoaingList';
import { withFormName } from '../../../../common/hoc/withFormName';

export default compose(
  withLoadingList(
    props => props.shops,
    EmptyList,
  ),
  withFormName,
  connect((state, props) => ({
    formValues: getFormValues(props.form)(state),
  }), { changeField: change }),
  withProps(props => ({
    allSelected: every(props.shops, shop => get(props.formValues, ['shops', shop.id, 'enabled'])),
  })),
  withHandlers({
    setAllSelected: props => (enabled) => {
      props.shops.forEach((shop) => {
        if (get(props.formValues, ['shops', shop.id, 'enabled']) && enabled) {
          return;
        }

        props.changeField(props.form, `shops.${shop.id}.enabled`, enabled);
      });
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.shops.length !== 1) {
        return;
      }

      const firstShopId = this.props.shops[0].id;

      if (get(this.props.formValues, ['shops', firstShopId, 'enabled'])) {
        return;
      }

      this.props.changeField(this.props.form, `shops.${firstShopId}`, { id: firstShopId, enabled: true });
    },
  }),
)(ShopTable);
